<template>
    <div class="tasks">
        <a-table :dataSource="sortedTasks" :columns="columns" :pagination="false" :loading="loading">
            <span slot="subject" slot-scope="text">{{ text }}</span>
            <span slot="owner" slot-scope="owner">{{ owner.name }}</span>
            <span slot="status" slot-scope="status">
                <a-tag :color="getStatusColor(status)">{{ status }}</a-tag>
            </span>
            <span slot="priority" slot-scope="priority">
                <a-tag :color="getPriorityColor(priority)">{{ priority }}</a-tag>
            </span>
            <span slot="dueDate" slot-scope="dueDate">{{ formatDate(dueDate) }}</span>
            <!-- Diğer önemli alanlar için slot'lar ekleyebilirsiniz -->
        </a-table>
    </div>
</template>

<script>
import Vue from "vue";
import { ZOHO_API } from "../../../../api/zoho";

export default Vue.extend({
    name: "Tasks",
    props: {
        module: {
            type: String,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            tasks: [],
            loading: false,
            columns: [
                {
                    title: "Konu",
                    dataIndex: "Subject",
                    scopedSlots: { customRender: "subject" },
                },
                {
                    title: "Sahibi",
                    dataIndex: "Owner",
                    scopedSlots: { customRender: "owner" },
                },
                {
                    title: "Durum",
                    dataIndex: "Status",
                    scopedSlots: { customRender: "status" },
                },
                {
                    title: "Öncelik",
                    dataIndex: "Priority",
                    scopedSlots: { customRender: "priority" },
                },
                {
                    title: "Bitiş Tarihi",
                    dataIndex: "Due_Date",
                    scopedSlots: { customRender: "dueDate" },
                },
                // Diğer önemli alanları burada ekleyebilirsiniz
            ],
        };
    },
    async created() {
        await this.fetchTasks();
    },
    computed: {
        sortedTasks() {
            return this.tasks.slice().sort((a, b) => new Date(b.Created_Time) - new Date(a.Created_Time));
        },
    },
    methods: {
        async fetchTasks() {
            this.loading = true;
            try {
                this.tasks = await ZOHO_API.listTasks(this.module, this.id);
            } catch (error) {
            } finally {
                this.loading = false;
            }
        },
        formatDate(dateString) {
            if (!dateString) return "";
            return new Date(dateString).toLocaleDateString("tr-TR", {
                year: "numeric",
                month: "long",
                day: "numeric",
            });
        },
        getPriorityColor(priority) {
            switch (priority) {
                case 'High':
                case 'Yüksek':
                    return 'red';
                case 'Medium':
                case 'Orta':
                    return 'orange';
                case 'Low':
                case 'Düşük':
                    return 'green';
                default:
                    return 'blue';
            }
        },
        getStatusColor(status) {
            switch (status) {
                case 'Not Started':
                case 'Başlanmadı':
                    return 'orange';
                case 'In Progress':
                case 'Devam Ediyor':
                    return 'processing';
                case 'Completed':
                case 'Tamamlandı':
                    return 'success';
                default:
                    return 'default';
            }
        },
    },
});
</script>

<style scoped lang="scss">
.tasks {
    // Gerekli stilleri burada ekleyebilirsiniz
}
</style>
